module.exports = __webpack_public_path__ + "static/fancyTitleDefault-22802d278ffcae8fab4a74d59c66f42d.png";